function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ed958a1d81"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "842c0eb24e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 187.5 37.5 C 104.65625 37.5 37.5 104.65625 37.5 187.5 C 37.5 270.34375 104.65625 337.5 187.5 337.5 C 270.34375 337.5 337.5 270.34375 337.5 187.5 C 337.5 104.65625 270.34375 37.5 187.5 37.5 Z M 187.5 37.5 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "ce9b84ad6f"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 109 145.546875 L 266 145.546875 L 266 187 L 109 187 Z M 109 145.546875 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "1b1b559f67"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 101 189 L 274.246094 189 L 274.246094 208 L 101 208 Z M 101 189 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "71b053214c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 129 203 L 135 203 L 135 229.546875 L 129 229.546875 Z M 129 203 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "98f9b9029c"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 118 225 L 146 225 L 146 229.546875 L 118 229.546875 Z M 118 225 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "21a2e0ff5e"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 185 203 L 190 203 L 190 229.546875 L 185 229.546875 Z M 185 203 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "a68b1f542d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 174 225 L 201 225 L 201 229.546875 L 174 229.546875 Z M 174 225 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "52d180053b"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 241 203 L 246 203 L 246 229.546875 L 241 229.546875 Z M 241 203 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "5d98497c9d"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 229 225 L 257 225 L 257 229.546875 L 229 229.546875 Z M 229 225 ",
  clipRule: "nonzero"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "eb8f23a623"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 269 178 L 274.246094 178 L 274.246094 196 L 269 196 Z M 269 178 ",
  clipRule: "nonzero"
})));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ed958a1d81)"
}, /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#842c0eb24e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#00f882",
  d: "M 37.5 37.5 L 337.5 37.5 L 337.5 337.5 L 37.5 337.5 Z M 37.5 37.5 ",
  fillOpacity: 1,
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  strokeLinecap: "butt",
  transform: "matrix(0.75, 0, 0, 0.75, 37.500002, 37.499998)",
  fill: "none",
  strokeLinejoin: "miter",
  d: "M 200.00001 0.00000328333 C 89.54167 0.00000328333 -0.00000271667 89.541676 -0.00000271667 200.000016 C -0.00000271667 310.458357 89.54167 400.00003 200.00001 400.00003 C 310.458351 400.00003 400.000024 310.458357 400.000024 200.000016 C 400.000024 89.541676 310.458351 0.00000328333 200.00001 0.00000328333 Z M 200.00001 0.00000328333 ",
  stroke: "#ffffff",
  strokeWidth: 36,
  strokeOpacity: 1,
  strokeMiterlimit: 4
})));
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ce9b84ad6f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 220.921875 186.460938 L 220.921875 153.027344 C 220.921875 148.90625 224.269531 145.554688 228.390625 145.554688 L 257.683594 145.554688 C 261.804688 145.554688 265.152344 148.90625 265.152344 153.027344 L 265.152344 186.460938 Z M 109.878906 186.460938 L 109.878906 153.027344 C 109.878906 148.90625 113.226562 145.554688 117.347656 145.554688 L 146.640625 145.554688 C 150.757812 145.554688 154.109375 148.90625 154.109375 153.027344 L 154.109375 186.460938 Z M 165.398438 186.460938 L 165.398438 153.027344 C 165.398438 148.90625 168.75 145.554688 172.871094 145.554688 L 202.164062 145.554688 C 206.28125 145.554688 209.632812 148.90625 209.632812 153.027344 L 209.632812 186.460938 Z M 165.398438 186.460938 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref5 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#1b1b559f67)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 270.0625 207.164062 L 104.96875 207.164062 C 102.792969 207.164062 101.015625 205.386719 101.015625 203.210938 L 101.015625 193.792969 C 101.015625 191.613281 102.792969 189.839844 104.96875 189.839844 L 270.0625 189.839844 C 272.238281 189.839844 274.011719 191.613281 274.011719 193.792969 L 274.011719 203.210938 C 274.011719 205.386719 272.238281 207.164062 270.0625 207.164062 Z M 270.0625 207.164062 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref6 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#71b053214c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 131.996094 229.476562 C 130.878906 229.476562 129.972656 228.570312 129.972656 227.453125 L 129.972656 205.140625 C 129.972656 204.027344 130.878906 203.125 131.996094 203.125 C 133.109375 203.125 134.011719 204.027344 134.011719 205.140625 L 134.011719 227.453125 C 134.011719 228.570312 133.109375 229.476562 131.996094 229.476562 Z M 131.996094 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref7 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#98f9b9029c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 143.148438 229.476562 L 120.835938 229.476562 C 119.722656 229.476562 118.820312 228.570312 118.820312 227.453125 C 118.820312 226.339844 119.722656 225.433594 120.835938 225.433594 L 143.148438 225.433594 C 144.265625 225.433594 145.171875 226.339844 145.171875 227.453125 C 145.171875 228.570312 144.265625 229.476562 143.148438 229.476562 Z M 143.148438 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref8 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#21a2e0ff5e)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 187.515625 229.476562 C 186.398438 229.476562 185.496094 228.570312 185.496094 227.453125 L 185.496094 205.140625 C 185.496094 204.027344 186.398438 203.125 187.515625 203.125 C 188.628906 203.125 189.535156 204.027344 189.535156 205.140625 L 189.535156 227.453125 C 189.535156 228.570312 188.628906 229.476562 187.515625 229.476562 Z M 187.515625 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref9 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#a68b1f542d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 198.671875 229.476562 L 176.359375 229.476562 C 175.246094 229.476562 174.339844 228.570312 174.339844 227.453125 C 174.339844 226.339844 175.246094 225.433594 176.359375 225.433594 L 198.671875 225.433594 C 199.789062 225.433594 200.691406 226.339844 200.691406 227.453125 C 200.691406 228.570312 199.789062 229.476562 198.671875 229.476562 Z M 198.671875 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref10 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#52d180053b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 243.039062 229.476562 C 241.925781 229.476562 241.019531 228.570312 241.019531 227.453125 L 241.019531 205.140625 C 241.019531 204.027344 241.925781 203.125 243.039062 203.125 C 244.15625 203.125 245.058594 204.027344 245.058594 205.140625 L 245.058594 227.453125 C 245.058594 228.570312 244.15625 229.476562 243.039062 229.476562 Z M 243.039062 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref11 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#5d98497c9d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 254.195312 229.476562 L 231.882812 229.476562 C 230.765625 229.476562 229.863281 228.570312 229.863281 227.453125 C 229.863281 226.339844 230.765625 225.433594 231.882812 225.433594 L 254.195312 225.433594 C 255.308594 225.433594 256.214844 226.339844 256.214844 227.453125 C 256.214844 228.570312 255.308594 229.476562 254.195312 229.476562 Z M 254.195312 229.476562 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref12 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#eb8f23a623)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 271.992188 195.808594 C 270.878906 195.808594 269.976562 194.90625 269.976562 193.792969 L 269.976562 180.335938 C 269.976562 179.21875 270.878906 178.316406 271.992188 178.316406 C 273.109375 178.316406 274.011719 179.21875 274.011719 180.335938 L 274.011719 193.792969 C 274.011719 194.90625 273.109375 195.808594 271.992188 195.808594 Z M 271.992188 195.808594 ",
  fillOpacity: 1,
  fillRule: "evenodd"
}));
var _ref13 = /*#__PURE__*/React.createElement("path", {
  fill: "#5b3dad",
  d: "M 103.039062 195.808594 C 101.921875 195.808594 101.015625 194.90625 101.015625 193.792969 L 101.015625 180.335938 C 101.015625 179.21875 101.921875 178.316406 103.039062 178.316406 C 104.152344 178.316406 105.054688 179.21875 105.054688 180.335938 L 105.054688 193.792969 C 105.054688 194.90625 104.152344 195.808594 103.039062 195.808594 Z M 103.039062 195.808594 ",
  fillOpacity: 1,
  fillRule: "evenodd"
});
function SvgIcono6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono6);
export default __webpack_public_path__ + "static/media/icono6.36062359b698ed33892ca0d40711f485.svg";
export { ForwardRef as ReactComponent };